var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside is-placed-right"},[_c('div',{ref:"container",staticClass:"aside-container",on:{"mouseenter":_vm.psUpdate}},[_c('aside-updates',{on:{"data-updated":_vm.psInit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }